import {Navigate} from "react-router-dom";
import Cookies from "universal-cookie";
const cookies = new Cookies();


const ProtectedRoute = ({children}) => {
    const token = cookies.get("token");
    return token ? children : <Navigate to="/Login"/>;
}

export default ProtectedRoute;